import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_BACKUP = "backup-management-service";

const RESOURCES = {
	LIST_BACKUPS: (licenceId) => `${BASE_BACKUP}/backups/licenses/${licenceId}`,
	LIST_BACKUPS_PAGINATED: (page, searchText, licenseId, orderBy) =>
		`${BASE_BACKUP}/backups/licenses/${licenseId}/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
	DOWNLOAD_BACKUP_BY_ID: (backupId) =>
		`${BASE_BACKUP}/backups/${backupId}/file`,
	UPLOAD_BACKUP: (serialNumber) =>
		`${BASE_BACKUP}/backups/${serialNumber}`,
	DELETE_BACKUP_BY_ID: (backupId, licenceId) =>
		`${BASE_BACKUP}/backups/${backupId}`,
	IMPORT: (backupId) =>
		`${BASE_BACKUP}/backups/${backupId}/import`,
	CREATE_BACKUP_CONFIG: (organizationId, licenseId) =>
		`${BASE_BACKUP}/backup-configs/organizations/${organizationId}/licenses/${licenseId}`,
	UPDATE_BACKUP_CONFIG: (configId, organizationId, licenseId) =>
		`${BASE_BACKUP}/backup-configs/${configId}/organizations/${organizationId}/licenses/${licenseId}`,
	LIST_BACKUP_CONFIGS: (organizationId) => `${BASE_BACKUP}/backup-configs/organizations/${organizationId}`,
};

class BackupService {
	static async listBackupsPaginated(
		page,
		searchText,
		licenseId,
		orderBy,
		cancelToken,
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_BACKUPS_PAGINATED(
					page,
					searchText,
					licenseId,
					orderBy,
				),
				{
					signal: cancelToken,
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar backups",
			});
			return error;
		}
	}
	static async listBackupsByLicence(licenceId) {
		try {
			return await axios.get(RESOURCES.LIST_BACKUPS(licenceId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar backups",
			});
			return error;
		}
	}
	static async downloadBackupById(backupId) {
		try {
			return await axios.get(RESOURCES.DOWNLOAD_BACKUP_BY_ID(backupId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao realizar download do backups",
			});
			return error.response;
		}
	}
	static async uploadBackup(formData, serialNumber) {
		try {
			return await axios.post(
				RESOURCES.UPLOAD_BACKUP(serialNumber),
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao fazer upload do backup",
			});
			return error.response;
		}
	}
	static async import(backupId, targetUnitId, replicationUnitIds, password, isMirrorMode, defaultUnitTag) {
		try {
			return await axios.post(
				RESOURCES.IMPORT(backupId),
				{
					password,
					targetUnitId: Number(targetUnitId),
					replicationUnitIds: replicationUnitIds?.map(Number) ?? null,
					isMirrorMode,
					defaultUnitTag,
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao importar backup",
			});
			return error.response;
		}
	}
	static async deleteBackupById(backupId, licenceId) {
		try {
			return await axios.delete(
				RESOURCES.DELETE_BACKUP_BY_ID(backupId, licenceId),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao deletar backup",
			});
			return error.response;
		}
	}
	static async listBackupConfigsByOrganization(organizationId) {
		try {
			return await axios.get(RESOURCES.LIST_BACKUP_CONFIGS(organizationId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar configurações de backup",
			});
			return error;
		}
	}
	static async createBackupConfig(payload, organizationId, licenseId) {
		try {
			const response = await axios.post(RESOURCES.CREATE_BACKUP_CONFIG(organizationId, licenseId), payload);
			ResponseAlerts({
				response: response,
				successMessage: "Configuração de backup salva com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao salvar configuração de backup",
			});
			return error.response;
		}
	}
	static async updateBackupConfig(id, organizationId, licenseId, payload) {
		return await axios
			.put(RESOURCES.UPDATE_BACKUP_CONFIG(id, organizationId, licenseId), payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Configuração de backup atualizada com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar configuração de backup",
				});
				return error.response;
			});
	}
	static async getUsedSpace(serialNumber) {
		try {
			return await axios.get(`${BASE_BACKUP}/backups/used-space/${serialNumber}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: `Erro ao obter espaço utilizado na licença ${serialNumber}`,
			});
			return error.response;
		}
	}
	static async getCurrentImporting(serialNumber) {
		try {
			return await axios.get(`${BASE_BACKUP}/backups/current-importing/${serialNumber}`);
		} catch (error) {
			console.log(error);
		}
	}
	static async getImportationItemsError(importationId) {
		try {
			return await axios.get(`${BASE_BACKUP}/backups/importation-errors/${importationId}`);
		} catch (error) {
			console.log(error);
		}
	}
}

export default BackupService;
